/**
 * 客户回款，银行登记单 新增页面 表单配置处理
 * @author zjs
 * @time 2017-10-25
 */
export default {
    data () {
        return {
            // 表单组件配置
            formConfig: [{
                name: "账户编码",
                type: "ElInput",
                field: "account_code",
            },{
                name: "账户全称",
                type: "ElInput",
                field: "account_full_name",
            },{
                name: "账户名称",
                type: "ElInput",
                field: "account_name",
            },{
                name: "账户所属人",
                type: "ElInput",
                field: "person_account",
            },{
                name: "收款账号",
                type: "ElInput",
                field: "account_number",
            },{
                name: "所属公司",
                type: "ElInput",
                field: "company_name",
            },{
                name: "期初余额",
                type: "LyInputNumber",
                width: '220px',
                field: "qichu_balance",
            },{
                name: "开户网点",
                type: "ElInput",
                field: "kaihu_wangdian",
            },{
                name: "开户银行",
                type: "ElInput",
                field: "kaihu_bank",
            },{
                name: "操作时间",
                type: "LyDatePicker",
                field: "work_time",
                json: {
                    type: 'date',
                    disabled: true
                },
                default: ""
            },{
                name: "创建人",
                type: "ElInput",
                field: "submiter",
                json: {
                    disabled: true
                },
                default: ""
            },{
                name: "是否现金收款",
                type: "LySelect",
                field: "is_cash",                
                json: {
                    all: false,
                    api:'',
                    data: [{
                        value: '1',
                        label: '是'
                    }, {
                        value: '0',
                        label: '否'
                    }]
                },
                default: "0"
            }]
        }
    }
}